import type { IPlace } from "@bbj-types/address";
import { isValidPhoneNumber } from "@root/utils/phoneLib";
import { type InferType, mixed, object, string } from "yup";

export const EMAIL_OR_PHONE_ERROR_MESSAGE = "Veuillez entrer au moins un numéro de téléphone ou une adresse email.";

export const contactSchema = object({
  _id: string().optional(),
  firstName: string().optional(),
  lastName: string().optional(),
  job: string().optional(),
  email: string()
    .email("Le format de l'email n'est pas valide")
    .test("email-or-phone", function (value) {
      return Boolean(value || this.parent.phone);
    }),
  phone: string()
    .test("valid-phone", "Le format du numéro n'est pas valide", (value) => !value || isValidPhoneNumber(value))
    .test("email-or-phone", function (value) {
      return Boolean(value || this.parent.email);
    }),
  place: mixed<IPlace>().required("Ce champ est obligatoire"),
  description: string().optional(),
});

export type ContactResolver = InferType<typeof contactSchema>;

const contactWithoutPlaceSchema = contactSchema.omit(["place"]);

export const getContactSchema = (place: boolean) => (place ? contactSchema : contactWithoutPlaceSchema);
